import { render, staticRenderFns } from "./DocumentsListManager.vue?vue&type=template&id=dd02cc40&scoped=true&"
import script from "./DocumentsListManager.vue?vue&type=script&lang=js&"
export * from "./DocumentsListManager.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListManager.vue?vue&type=style&index=0&id=dd02cc40&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd02cc40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
